import { render } from "./ManufacturerManagement.vue?vue&type=template&id=79d123a7&scoped=true"
import script from "./ManufacturerManagement.vue?vue&type=script&lang=js"
export * from "./ManufacturerManagement.vue?vue&type=script&lang=js"

import "./ManufacturerManagement.vue?vue&type=style&index=0&id=79d123a7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d123a7"]])

export default __exports__